import clsx from 'clsx';

import * as styles from './index.css';

export interface SidebarFloatingMaskProps {
  open: boolean;
  floating: boolean;
  testId: string;
  className?: string;
  onClick: () => void;
}

export const SidebarFloatingMask = ({
  open,
  floating,
  testId,
  className,
  onClick,
}: SidebarFloatingMaskProps) => {
  return (
    <div
      aria-hidden="true"
      className={clsx(styles.sidebarFloatingMask, className)}
      data-is-floating={floating}
      data-open={open}
      data-testid={testId}
      onClick={onClick}
    />
  );
};
